import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Sparkles } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { T } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ArticlesPage() {
  const [articles, setArticles] = useState([]);
  const [tag, setTag] = useState("All");

  useEffect(() => {
    axios.get(`${API}/articles`).then((r) => setArticles(r.data)).catch(() => {});
  }, []);

  const tags = ["All", ...new Set(articles.flatMap((a) => a.tags))].slice(0, 18);
  const shown = tag === "All" ? articles : articles.filter((a) => a.tags.includes(tag));

  return (
    <div>
      <PageHero topic="sports writing editorial desk" title="SportsPulse Editorial" subtitle="AI-assisted articles on the games, business, health and history of world sport — tagged, published and reviewed for accuracy." listenTargetId="page-content" />
      <div id="page-content" className="mx-auto max-w-7xl space-y-8 px-4 py-12 sm:px-6">
        <div className="flex flex-wrap gap-2" data-testid="article-tag-filters">
          {tags.map((t) => (
            <button key={t} data-testid={`article-tag-${t.toLowerCase()}`} onClick={() => setTag(t)} className={`rounded-full px-4 py-1.5 text-sm font-bold transition-colors ${tag === t ? "bg-[#0055FF] text-white" : "border border-slate-200 bg-white text-slate-600 hover:border-[#0055FF] hover:text-[#0055FF]"}`}>
              {t === "All" ? <T>All</T> : t}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="articles-grid">
          {shown.map((a) => (
            <Link key={a.article_id} to={`/articles/${a.article_id}`} data-testid={`article-card-${a.article_id}`} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg">
              <div className="flex flex-wrap items-center gap-1.5">
                <span className="inline-flex items-center gap-1 rounded-full bg-blue-100 px-2.5 py-1 text-xs font-bold text-blue-700"><Sparkles className="h-3 w-3" /><T>AI-generated</T></span>
                <span className="rounded-full bg-purple-100 px-2.5 py-1 text-xs font-bold text-purple-700"><T>{a.section}</T></span>
              </div>
              <h3 className="mt-3 text-lg font-bold leading-snug text-slate-900"><T>{a.title}</T></h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600"><T>{a.summary}</T></p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {a.tags.map((t) => <span key={t} className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600">#{t}</span>)}
              </div>
            </Link>
          ))}
          {articles.length === 0 && <p className="col-span-full py-12 text-center text-sm text-slate-500"><T>Articles are being written by the editorial AI — check back in a minute.</T></p>}
        </div>
      </div>
    </div>
  );
}
